import {NuxtIcon} from "#components";
import {h} from "vue";
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 311.1 106.8"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      d: "M20.5 92.3c62 9.7 87.8-14.9 126.2-45.9C185.6 15 214.3-5.1 285.6 16.9 226.2 3.5 187 35.1 159 58.7 137.7 76.6 91.4 114 20.4 92.3Z",
      style: {"fill":"#cf152d"}
    }, null, -1),
    _createElementVNode("path", {
      d: "M46 100.2c62 9.7 87.8-14.9 126.2-45.9 38.9-31.4 67.6-51.5 138.9-29.5-59.4-13.4-98.6 18.2-126.6 41.8-21.3 17.9-67.6 55.3-138.6 33.6Z",
      style: {"fill":"#008ec8"}
    }, null, -1),
    _createElementVNode("path", {
      d: "M0 85.2C54.2 94.5 86.9 67.9 125.5 37c36.7-29.4 59.6-48.3 130.3-29.4-59.7-10.2-90.6 17.3-118.6 41C115.9 66.5 69.4 106.2 0 85.2Z",
      style: {"fill":"#fad665"}
    }, null, -1)
  ]))]))
}
export default { render() { return h(NuxtIcon, {icon: {render}, name: "7I-logo"}) } }